var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('convenios',{attrs:{"ConveniosServicos":_vm.obterDataServicos(),"rotaDetalhar":"Gescon_Convenios_Gestor_Detalhar","rotaListagem":"Gescon_Convenios_Gestor","temAcessoDetalhar":_vm.$temAcessoView('GESCON-GEST-CONV-02')}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }